import axios from 'axios';
import { DeepReadonly } from 'utility-types';
import { IFeatureFlag } from '../interfaces/featureFlag';

//these refer to uppercase and lowercase base64 values for true
const base64TrueUppercase = 'VHJ1ZQ==';
const base64TrueLowercase = 'dHJ1ZQ==';

export const mappedFeatureFlags = (consulFlags: DeepReadonly<IFeatureFlag[]>) =>
  Object.assign(
    {},
    ...consulFlags.map(({ Key, Value }) => ({
      [Key.replace('FeatureManagement:', '')]:
        Value === base64TrueUppercase ? true : Value === base64TrueLowercase ? true : false
    }))
  );

const fetchFeatureFlags = async (): Promise<IFeatureFlag[] | null> => {
  try {
    const response = await axios.get<IFeatureFlag[]>('/spapi/featureFlags');
    return response.data;
  } catch (e) {
    return null;
  }
};

export const isFeatureEnabled = async (featureFlagKey: string) => {
  const featureFlags = await fetchFeatureFlags();
  if (featureFlags?.length) {
    const featureFlag = featureFlags.find(item => item.Key === `FeatureManagement:${featureFlagKey}`);
    return featureFlag?.Value === base64TrueUppercase || featureFlag?.Value === base64TrueLowercase;
  }
  return false;
};
